import template from './leave_trends_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTrendsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTrendsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTrendsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTrendsHelp',
	dialog_class: LeaveTrendsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_trends_help',
	provider: 'ps'
};
